<template>
  <div class="login_wrap" v-loading="loading" v-if="!loading">
    <div class="login_header">
      <div class="login_icon"></div>
      <span class="login_title"></span>
    </div>
    <div class="login_info">
      <div class="digital_economy">
      </div>
      <p class="describe">
        提供数据要素资源化、产品化、资产化与资本化的全流程管理
      </p>
    </div>
    <div class="login_left">

    </div>
    <div class="sys_tab">
      <el-radio-group v-model="sysIdentityValue" @change="handleIdentityChange">
        <el-radio-button label="dataAsset">数据资产管理</el-radio-button>
        <el-radio-button label="metaData">元数据管理</el-radio-button>
      </el-radio-group>
    </div>
    <div class="login_right">
<!--      <div class="lang" v-if="false">-->
<!--        <div :class="ruleForm.langType == 'zh-CN' ? 'avtive' : ''" @click="ruleForm.langType = 'zh-CN'">-->
<!--          中文-->
<!--        </div>-->
<!--        <div :class="ruleForm.langType == 'en-US' ? 'avtive' : ''" @click="ruleForm.langType = 'en-US'">-->
<!--          English-->
<!--        </div>-->
<!--      </div>-->
      <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" label-width="0">
        <p class="tips">欢迎登录</p>
        <el-form-item prop="username" label="">
          <el-input v-model="ruleForm.username" placeholder="账号" autocomplete="off" maxlength="30" class="input-width"
            @keyup.enter.native="submit('ruleForm')">
            <i slot="prefix">
              <span class="input-icon user"></span>
            </i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password" label="">
          <el-input v-model="ruleForm.password" placeholder="密码" show-password maxLength="15" class="input-width"
            @keyup.enter.native="submit('ruleForm')">
            <i slot="prefix">
              <span class="input-icon lock"></span>
            </i>
          </el-input>
        </el-form-item>
        <el-form-item prop="validCode" style="margin-bottom: 8px" label="">
          <el-input v-model="ruleForm.validCode" placeholder="验证码" autocomplete="off" maxLength="5" class="input-width"
            @keyup.enter.native="submit('ruleForm')" style="width: 280px;">
            <i slot="prefix">
              <span class="input-icon shield-check"></span>
            </i>
          </el-input>
          <div class="verificationCode_btn" @click="getCode">
            <img :src="imgurl" alt="加载失败" title="看不清？换一张" />
          </div>
          <el-input v-model="ruleForm.uuid" v-show="false"></el-input>
        </el-form-item>
        <el-form-item style="margin: 0">
          <el-button type="primary"
            :style="{ 'color': '#fff', 'background': 'linear-gradient(90deg, #3EBDFF 0%, #1C83FF 100%)', 'height': '54px', opacity: !(ruleForm.username && ruleForm.password && ruleForm.validCode) ? 0.7 : 1 }"
            :disabled="!(ruleForm.username && ruleForm.password && ruleForm.validCode)"
            @click="submit('ruleForm')">登录</el-button>
        </el-form-item>
        <el-form-item style="margin: 0">
          <span class="slogan">释放无限创意，智慧由你定义</span>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import * as api from "../api/userApi";
import axios from "axios";
import { Base64 } from "js-base64";
import {mapMutations, mapState} from 'vuex'
import {findByOrgIdOrDomain} from "../api/userApi";
export default {
  data () {
    return {
      sysIdentityValue: "dataAsset",
      identityObj: {
        dataAsset: "数据资产管理",
        metaData: "元数据管理"
      },
      ruleForm: {
        username: "",
        password: "",
        validCode: "",
        uuid: "",
        deviceId: "",
        grant_type: "password_code",
        client_id: "webApp",
        client_secret: "webApp",
        langType: 'zh-CN'
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        validCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      imgurl: "",
      loading: true,
    };
  },
  computed: {
    ...mapState("system", ['sysIdentity'])
  },
  watch: {
      sysIdentity(newValue){
          this.sysIdentityValue = newValue;
      }
  },
  beforeMount () {
    sessionStorage.clear()
  },
  mounted () {
    // 被iframe嵌套
    if(window.self !== window.top){
      let jumpObj = JSON.stringify({type: 'khd'});
      localStorage.setItem("jumpObj", jumpObj);
    } else {
      localStorage.setItem("jumpObj", "{}");
      this.setIsClient(true);
    }
    this.getCode();
    if (window.location.href.split('?').length > 1) {
      this.getParam(window.location.href)
    } else {
      this.loading = false
    }
    if (this.isPort(window.location.host)) {
      this.$set(this.ruleForm, 'username', 'wanglei')
      this.$set(this.ruleForm, 'password', '123456')
      this.$set(this.ruleForm, 'validCode', '1')
    }
  },
  methods: {
    ...mapMutations('system', ['setUserData', 'setIsClient', 'setSysIdentity']),
    handleIdentityChange(value){
      this.setSysIdentity(value);
    },
    getQuestionEventById (token, id) {//根据试题ID获取事项
      axios({
        url: `${process.env.ZL_EDU_API}/api-resource/questionAnswer/findQuestionAnswerByQuestionId/${id}`,
        method: "get",
        headers: {
          'Authorization': 'bearer ' + token,
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }).then((rs) => {
        if (rs.data.code == 0) {
          let list = rs.data.data
          let initdata = null
          list.forEach(v => {
            if (v.initdata) {
              initdata = JSON.parse(v.initdata)
            }
          })
          if (initdata) {
            let code = initdata['项目编码']
            sessionStorage.setItem('projectCodes', code)
          }
        } else {
          this.$messageError(rs.data.msg)
        }
      }).then(() => {
        // 初始化
        this.getInit()
      })
    },
    getInit () {
      api.getInit({ code: sessionStorage.getItem('projectCodes') }).then((res) => {
        if (res.data) {
          this.getMentList(sessionStorage.getItem("menuCode"))
        }
      })
    },
    getParam (str) {//跳转参数解析
      sessionStorage.setItem('isPreset', 0)
      let obj = JSON.parse(localStorage.getItem("jumpObj"))
      if (obj.type && obj.type == 'khd') {
        let token = obj.token;
        sessionStorage.setItem("Authorization", token);
        this.getCurrentUser(obj.type)
      } else {
        sessionStorage.setItem("Authorization", obj.token);
        sessionStorage.setItem("nickname", Base64.decode(obj.nickname));
        sessionStorage.setItem("userId", obj.userId);//历史测试数据ID：85143
        sessionStorage.setItem("questionId", obj.questionId);
        sessionStorage.setItem('keyId', (obj.keyId && obj.keyId != '0000') ? obj.keyId : obj.userId);
        sessionStorage.setItem("sourceId", obj.sourceId);
        sessionStorage.setItem("productName", obj.productName ? Base64.decode(obj.productName) : "中联大数据平台");
        sessionStorage.setItem("productCode", obj.productCode ? obj.productCode : "bigDataAll");
        sessionStorage.setItem("prodName", Base64.decode(obj.prodName));
        sessionStorage.setItem("sxToken", obj.sxToken);
        sessionStorage.setItem("examType", obj.examType);
        sessionStorage.setItem("sex", obj.sex);
        sessionStorage.setItem("username", obj.username);
        sessionStorage.setItem("roleCodes", obj.roleCodes);

        this.getCurrentUserInfo()
        this.setUserData(obj)
        let menuCode = obj.menuCode ? this.unique(obj.menuCode.split(',')).join(',') : 'ALL'
        sessionStorage.setItem("menuCode", menuCode);
        this.getQuestionEventById(obj.sxToken, obj.questionId)
      }
    },
    getCurrentUserInfo () {
      api.getCurrentUser().then(res => {
        if (res.code == 0) {
          sessionStorage.setItem("openId", res.data.openId);
        } else {
          this.$messageError(rs.msg)
        }
      })
    },
    unique (arr) {
      if (!Array.isArray(arr)) {
        console.log('type error!')
        return
      }
      let res = []
      for (let i = 0; i < arr.length; i++) {
        if (res.indexOf(arr[i]) === -1) {
          res.push(arr[i])
        }
      }
      return res
    },
    submit (formName) {//登录
      sessionStorage.setItem('isPreset', '1')
      this.goLongin()
      return
      let host = window.location.host;
      if (this.isPort(host)) {
        let str = "https://dstest.cailian.net/#/?dG9rZW49NTg2ZTg2YTEtNzZhMS00OTRkLTg2YTgtMzdiNDkyZTFiODQ1Jmd4enhUb2tlbj0zZTYwNWE0OC0yYjE5LTQ4NjItODQ3Mi0yMTA2NmFlM2RlNjEmdXNlcklkPTc3MzYmaXNUZWFtU2hhcmU9MCZrZXlJZD0mcm9sZUNvZGU9MzAwNSZ0ZW1wbGF0ZUNvZGU9MDAxJnNvdXJjZUlkPVRFQUNIXzIzNDRfMzc4Ml8xX05PTkUmbWVudUNvZGU9QUxMJmlkPTE4MDkzJm5pY2tuYW1lPTVMaXQ2SUdVNTVTMTVaV0dNUT09JnByb2R1Y3RDb2RlPVNvY2lhbEFsbCZwcm9kdWN0TmFtZT01TGl0NklHVTU2Uys1THFrNTVTMTVaV0c="
        this.getParam(str)
      } else {
        sessionStorage.setItem('isPreset', '1')
        this.goLongin()
      }
    },
    goLongin () {//网站登录
      let data = new URLSearchParams()
      data.append('grant_type', 'password_code')
      data.append('username', this.ruleForm.username)
      data.append('password', this.ruleForm.password)
      data.append('validCode', this.ruleForm.validCode)
      data.append('deviceId', this.ruleForm.uuid)

      axios({
        url: `${process.env.BASE_API}/api-oauth/oauth/token`,
        method: "post",
        data: data,
        headers: {
          'Authorization': 'Basic ' + window.btoa(this.ruleForm.client_id + ":" + this.ruleForm.client_secret),
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }).then((rs) => {
        if (rs.data.code == 0) {
          let token = rs.data.data.access_token;
          sessionStorage.setItem("Authorization", token);
          sessionStorage.setItem("username", this.ruleForm.username);
          localStorage.setItem('language', this.ruleForm.langType)
          this.$i18n.locale = this.ruleForm.langType
        } else {
          this.$messageError(rs.data.msg);
        }
      }).then(() => {
        this.getCurrentUser()
      })
    },
    getCurrentUser (type) {//获取用户信息
      api.getCurrentUser().then(rs => {
        // console.log(rs, "res")
        if (rs.code == 0) {
          this.setUserData(rs.data)
          let param = {
            nickname: rs.data.nickname,
            userId: rs.data.userId,
            orgId: rs.data.orgId,
            orgName: rs.data.orgName,
            sex: rs.data.sex,
            userType: rs.data.userType,
          }
          sessionStorage.setItem("username", rs.data.username);
          sessionStorage.setItem("nickname", param.nickname);
          sessionStorage.setItem("userId", param.userId);
          sessionStorage.setItem("sex", param.sex);
          sessionStorage.setItem("userType", param.userType);

          let roleArr = []
          rs.data.roles.forEach(v => {
            if (v.subSystem.indexOf('dataAsset') > -1) {
              roleArr.push(v.id)
            }
          })
          this.findOrgsByUserId(rs.data.userId)
          this.getSysMentList(roleArr, type)
        } else {
          this.$messageError(rs.msg)
        }
      })
    },
      async findOrgsByUserId(userId){
        let res = await api.findOrgsByUserId({
            userId,
            sourceSysType: 1
        });
        if(res.length > 0){
            await this.findByOrgIdOrDomain(res[0].id)
        }
      },
      async findByOrgIdOrDomain(orgId){
          let res = await api.findByOrgIdOrDomain(orgId);
          if(res.code === 0){
              if(res.data && res.data.extend.length > 0){
                sessionStorage.setItem('eduExtend', res.data.extend)
                let eduExtend = JSON.parse(res.data.extend);
                document.title = eduExtend.pageTitle || '数据资产管理平台';
                const link = document.createElement('link');
                link.rel = 'icon';
                link.href = eduExtend.ico || "./static/favicon.ico"; // 替换为你的图标路径
                document.head.appendChild(link);
              }
          }
      },
    getTree (tree, type) {//获取菜单
      let role = []
      if (tree) {
        role = tree
      }
      sessionStorage.setItem("routerList", JSON.stringify(role));
      if (type) {
        sessionStorage.setItem('isPreset', '1')
        let obj = JSON.parse(localStorage.getItem("jumpObj"))
        this.$router.push({ path: `/${obj.url}` })
      } else {
        let url = ""
        if (role.length) {
          // url = role[0].url
          // url = '/staging'
          if(this.sysIdentity === "metaData"){
            url = '/data-source-manage'
          }
          if(this.sysIdentity === "dataAsset"){
            url = '/account-info'
          }
        } else {
          url = "/no-permission"
        }
        this.$router.push({ path: url })
      }
    },
    getMentList (role) {
      //获取路由
      api.getMenuList({
        sysIdentity: this.sysIdentity,//系统标识
        productIdEntity: sessionStorage.getItem('productCode') ? sessionStorage.getItem('productCode') : "bigDataAll",//产品标识
        roleIdentity: role,//角色标识
      }).then(rs => {
        if (rs.code == 0) {
          let btnPerms = rs.data.btnPerms
          sessionStorage.setItem('btnPerms', JSON.stringify(btnPerms))
          this.getTree(rs.data.tree);
        } else {
          this.$messageError(rs.msg)
        }
      })
    },
    getSysMentList (role, type) {
      //获取路由
      api.getMenuList({
        sysIdentity: this.sysIdentity,//系统标识
        roleId: role.join(',')
      }).then(rs => {
        if (rs.code == 0) {
          let btnPerms = rs.data.btnPerms
          sessionStorage.setItem('btnPerms', JSON.stringify(btnPerms))
          this.getTree(rs.data.tree, type);
        } else {
          this.$messageError(rs.msg)
        }
      })
    },
    getCode () {//验证码
      let uuid = this.getUUID();
      this.ruleForm.uuid = uuid;
      var that = this;
      axios({
        url: `${process.env.BASE_API}/api-oauth/validata/code/${uuid}`,
        method: "get",
        headers: {
          "Content-type": "application/vnd.ms-excel;charset=utf-8",
        },
        responseType: "blob",
      })
        .then((res) => {
          const src = window.URL.createObjectURL(res.data);
          this.imgurl = src;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getUUID () {//uuid
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16).toUpperCase();
        }
      );
    },
    isPort (strPort) {
      if (this.isNull(strPort)) {
        return false;
      }
      // if (strPort == "localhost" || strPort == "dstest.cailian.net") {
      if (strPort == "localhost") {
        return true;
      } else if (strPort.indexOf(":") > -1) {
        return (
          this.isIp(strPort.split(":")[0]) ||
          (strPort.split(":")[0] == "localhost" ? true : false)
        );
      } else {
        return false;
      }
    },
    isNull (param) {
      return !param && param !== 0 && typeof param !== "boolean" ? true : false;
    },
    isIp (strIp) {
      if (this.isNull(strIp)) {
        return false;
      }
      let reg = /^(\d+).(\d+).(\d+).(\d+)$/g;
      if (reg.test(strIp)) {
        if (
          RegExp.$1 < 256 &&
          RegExp.$2 < 256 &&
          RegExp.$3 < 256 &&
          RegExp.$4 < 256
        ) {
          return true;
        }
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media screen and (min-width: 1440px) {
  .login_wrap {
    .login_info {
      position: absolute;
      top: 140px;
      left: 32%;

      .digital_economy {
        width: 624px;
        height: 56px;
        //width: 580px;
        //height: 52.2px;
      }

      .describe {
        font-size: 24px;
      }
    }

    .login_right {
      //width: 600px;
      //right: 200px;

      .demo-ruleForm {
        // margin-top: calc(50% - 100px);
        // margin-top: 30px;
        border-radius: 9px;
        border: 2px solid var(--Gray-White, #FFF);
        background: linear-gradient(180deg, #FFF 0%, #F8FAFF 100%);
        box-shadow: 0 4px 24px 0 rgba(89, 94, 111, 0.10);
        width: 100%;
        padding: 48px 32px 32px 32px;
        box-sizing: border-box;

        .input-width {
          //height: 48px;
          border-radius: 6px;
          border: 1px solid #DCDCDC;
          position: relative;

          .input-icon {
            position: absolute;
            top: 12px;
            left: 8px;
            width: 24px;
            height: 24px;

            &.user {
              background: url(../assets/imgs/login/user.png) no-repeat top left/auto 100%;
            }

            &.lock {
              background: url(../assets/imgs/login/lock.png) no-repeat top left/auto 100%;
            }

            &.shield-check {
              background: url(../assets/imgs/login/shield-check.png) no-repeat top left/auto 100%;
            }
          }
        }

        .tips {
          height: 40px;
          line-height: 40px;
          font-size: 28px;
          font-weight: 600;
          margin-bottom: 50px;
          text-align: left;
          color: #171721;

          img {
            height: 47px;
          }
        }

        button {
          margin: 50px 0;
        }
      }
    }

    /deep/ .el-form-item {
      margin-bottom: 21px;

      input {
        height: 48px;
        line-height: 48px;
      }
    }
  }
}

@media only screen and (max-width: 1440px) {
  .login_wrap {
    .login_info {
      position: absolute;
      top: 140px;
      left: 32%;

      .digital_economy {
        width: 510px;
        height: 46px;
      }

      .describe {
        font-size: 20px;
      }
    }
    .login_right {
      //width: 500px;
      //right: 130px;

      .demo-ruleForm {
        margin-top: 15%;
        width: 100%;
        background: rgba(255, 255, 255, 0.4);
        backdrop-filter: blur(50px);
        padding: 30px 60px 15px;
        box-sizing: border-box;

        //.tips {
        //  height: 32px;
        //  line-height: 32px;
        //  font-size: 30px;
        //  margin-bottom: 40px;
        //
        //  img {
        //    height: 40px;
        //  }
        //}

        button {
          margin: 18px 0;
        }
      }
    }

    /deep/ .el-form-item {
      margin-bottom: 18px;

      input {
        height: 40px;
        line-height: 40px;
      }
    }
  }
}

.login_wrap {
  width: 100%;
  height: 100%;
  min-height: 600px;
  //background: url(/static/imgs/login/background.png) no-repeat top left/auto 100%, rgb(233, 243, 255);
  background: url(../assets/imgs/login/login-background.png) no-repeat top left/auto 100%, rgb(233, 243, 255);
  background-size: 100% auto;
  overflow: hidden;
  .sys_tab{
    width: 460px;
    position: absolute;
    right: 156px;
    text-align: center;
    top: 4%;
  }
  .login_header{
    height: 56px;
    padding-top: 18px;
    padding-left: 48px;
    display: flex;
    align-items: center;
    .login_icon{
      width: 34px;
      height: 24px;
      background: url(../assets/imgs/login/header-icon.png) no-repeat;
      background-size: cover;
    }
    .login_title{
      width: 192px;
      height: 24px;
      margin-left: 16px;
      background: url(../assets/imgs/login/header-title.png) no-repeat top left/auto 100%;
      background-size: 100% auto;
    }
  }
  .login_info{
    position: absolute;
    top: 140px;
    left: 32%;
    transform: translate(-50%);
    .digital_economy{
      background: url(../assets/imgs/login/center-title.png) no-repeat top left/auto 100%;
      background-size: 100% auto;
    }
    .describe{
      margin-top: 8px;
      color: rgba(0, 0, 0, 0.6);
      line-height: 26px;
    }
  }
  .login_left{
    width: calc(64% - 260px);
    //width: calc(64% - 192px);
    height: 100%;
    margin-right: 192px;
    background: url(../assets/imgs/login/login-left.png) no-repeat top left/auto 100%;
    background-size: 100% auto;
    //margin-top: 100px;
    //margin-left: 20px;
    margin-top: 150px;
    margin-left: 68px;
  }
  .login_right {
    width: 460px;
    height: 538px;
    right: 156px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    box-sizing: border-box;

    .demo-ruleForm {
      border-radius: 9px;
      border: 2px solid var(--Gray-White, #FFF);
      background: linear-gradient(180deg, #FFF 0%, #F8FAFF 100%);
      box-shadow: 0 4px 24px 0 rgba(89, 94, 111, 0.10);
      width: 100%;
      padding: 48px 32px 32px 32px;
      box-sizing: border-box;

      .input-width {
        //height: 48px;
        border-radius: 6px;
        border: 1px solid #DCDCDC;
        position: relative;

        .input-icon {
          position: absolute;
          top: 12px;
          left: 8px;
          width: 24px;
          height: 24px;

          &.user {
            background: url(../assets/imgs/login/user.png) no-repeat top left/auto 100%;
          }

          &.lock {
            background: url(../assets/imgs/login/lock.png) no-repeat top left/auto 100%;
          }

          &.shield-check {
            background: url(../assets/imgs/login/shield-check.png) no-repeat top left/auto 100%;
          }
        }
      }

      .verificationCode_btn{
        display: inline-block;
        width: 100px;
      }

      .tips {
        height: 40px;
        line-height: 40px;
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 50px;
        text-align: left;
        color: #171721;

        img {
          height: 47px;
        }
      }

      .slogan{
        display: block;
        text-align: center;
        color: rgba(27, 37, 89, 0.50);
        font-size: 14px;
        font-weight: 300;
        line-height: 22px;
      }

      button {
        width: 100%;
        background: linear-gradient(136deg, #009cff 0%, #0064ff 100%);
        font-size: 20px;
        letter-spacing: 15px;
        color: #fff;
        font-weight: 500;
        //margin: 50px 0;
      }
    }
  }
}

.lang {
  width: 200px;
  height: 40px;
  display: flex;
  align-items: center;
  position: fixed;
  right: 120px;

  &>div {
    width: 100px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    color: rgba(24, 144, 255, 1);
  }

  .avtive {
    background: #fff;
    border-radius: 20px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  }
}

/deep/ .el-form-item {
  .el-form-item__label {
    font-size: 16px;
    color: #000;
  }

  input {
    background-color: rgba(255, 255, 255, 0.47);
    border: none;
    outline: none;
    border-radius: 0;
    padding: 0 12px 0 44px;
  }

  input::-webkit-input-placeholder {
    /* 使用webkit内核的浏览器 */
    color: #808080;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px;
    /* 142.857% */
  }

  input:-moz-placeholder {
    /* Firefox版本4-18 */
    color: #808080;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px;
    /* 142.857% */
  }

  input::-moz-placeholder {
    /* Firefox版本19+ */
    color: #808080;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px;
    /* 142.857% */
  }

  input:-ms-input-placeholder {
    /* IE浏览器 */
    color: #808080;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 20px;
    /* 142.857% */
  }
}
</style>



// WEBPACK FOOTER //
// src/newViews/Login.vue